<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

        <!-- 正常页面 -->
        <div v-else class="my-orders-page">
            <!-- 标签页 -->
            <van-tabs v-model:active="activeTab">
                <van-tab title="订购订单" name="subscription">
                    <!-- 订购订单内容 -->
                    <!-- 空状态 -->
                    <div v-if="subscriptionOrders.length === 0" class="empty-state">
                        <van-empty description="暂无订购订单" />
                    </div>
                    <!-- 订单列表 -->
                    <div v-else>
                        <div class="orders-content">
                            <div class="order-card" v-for="order in subscriptionOrders" :key="order.id">
                                <!-- 已取消印章 -->
                                <div class="cancelled-stamp" v-if="order.state === '取消'">
                                    已取消
                                </div>
                                <!-- 学生信息 -->
                                <div class="student-info">
                                    <div class="student-name">{{ order.student_name }}</div>
                                    <div class="student-details">{{ order.place_name }}/{{ order.grade_name }}/{{
                                        order.class_name }}</div>
                                </div>

                                <!-- 搭配套餐：仅赠送套卡时隐藏 -->
                                <div class="package-section" v-if="!order.is_present_card">
                                    <div class="section-title">搭配套餐</div>
                                    <div class="milk-week-list">
                                        <div class="milk-week-item" v-for="(item, index) in order.packages"
                                            :key="index">
                                            <div class="milk-week-card">
                                                <div class="milk-week-title">{{ item.day }}</div>
                                                <div class="milk-type-tag"
                                                    :style="{ background: item.type === 'fresh' ? '#3B82F6' : '#D50F5F' }">
                                                    {{ item.type === 'fresh' ? '鲜' : '酸' }}
                                                </div>
                                                <img class="milk-icon"
                                                    :src="item.type === 'fresh' ? require('@/assets/milk-fresh.png') : require('@/assets/milk-yogurt.png')" />
                                                <div class="milk-label"
                                                    :style="{ color: item.type === 'fresh' ? '#3B82F6' : '#D50F5F' }">
                                                    {{ item.type === 'fresh' ? '鲜奶' : '酸奶' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 订单详情：仅赠送套卡时隐藏部分字段 -->
                                <div class="order-details">
                                    <van-row v-if="!order.is_present_card">
                                        <van-col span="12">
                                            <div class="detail-item">
                                                <div class="detail-label">开始时间:</div>
                                                <div class="detail-value">{{ order.start_send_date }}</div>
                                            </div>
                                        </van-col>
                                        <van-col span="12">
                                            <div class="detail-item">
                                                <div class="detail-label">结束时间:</div>
                                                <div class="detail-value">{{ order.end_date }}</div>
                                            </div>
                                        </van-col>
                                    </van-row>
                                    <van-row v-if="!order.is_present_card">
                                        <van-col span="12">
                                            <div class="detail-item">
                                                <div class="detail-label">瓶数:</div>
                                                <div class="detail-value">{{ order.sum_num }}</div>
                                            </div>
                                        </van-col>
                                        <van-col span="12">
                                            <div class="detail-item" v-if="order.state !== '取消'">
                                                <div class="detail-label">已送瓶数:</div>
                                                <div class="detail-value">{{ order.send_num }}</div>
                                            </div>
                                        </van-col>
                                    </van-row>
                                    <van-row>
                                        <van-col span="12">
                                            <div class="detail-item">
                                                <div class="detail-label">订单金额:</div>
                                                <div class="detail-value price">¥{{ order.order_amount }}</div>
                                            </div>
                                        </van-col>
                                        <van-col span="12" v-if="!order.is_present_card">
                                            <div class="detail-item" v-if="order.state !== '取消'">
                                                <div class="detail-label">剩余瓶数:</div>
                                                <div class="detail-value">{{ order.not_send_num }}</div>
                                            </div>
                                        </van-col>
                                    </van-row>
                                </div>

                                <!-- 订单卡片：有卡片信息时显示（放在订单信息下方） -->
                                <div class="order-card-section" v-if="order.order_card_info && order.order_card_info.card_no">
                                    <div class="order-card-display"
                                         @click.stop="goToCardDetail(order.order_card_info)"
                                         @click.capture.stop
                                         :onclick="order.order_card_info.card_info_id ? `window.location.href='/card-detail?card_id=${order.order_card_info.card_info_id}';event.stopPropagation();event.preventDefault();return false;` : ''">
                                        <div class="order-card-header">
                                            <div class="order-card-title">
                                                <svg class="chip-card-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="2" y="4" width="20" height="16" rx="2.5" fill="none" stroke="#8B0000" stroke-width="1.2"/>
                                                    <rect x="2" y="8.2" width="20" height="2" fill="#8B0000" opacity="0.1"/>
                                                    <rect x="5" y="12.5" width="5.5" height="3.8" rx="0.6" fill="none" stroke="#8B0000" stroke-width="1.1"/>
                                                    <line x1="5" y1="13.8" x2="10.5" y2="13.8" stroke="#8B0000" stroke-width="0.9"/>
                                                    <line x1="5" y1="15" x2="10.5" y2="15" stroke="#8B0000" stroke-width="0.9"/>
                                                    <line x1="7.75" y1="12.5" x2="7.75" y2="16.3" stroke="#8B0000" stroke-width="0.9"/>
                                                </svg>
                                                <span>订单卡片</span>
                                            </div>
                                            <div class="order-card-type-tag">{{ order.order_card_info.card_type }}</div>
                                        </div>
                                        <div class="order-card-body">
                                            <div class="order-card-row">
                                                <span class="order-card-label">卡号：</span>
                                                <span class="order-card-value card-no">{{ order.order_card_info.card_no }}</span>
                                            </div>
                                            <div class="order-card-row">
                                                <span class="order-card-label">剩余：</span>
                                                <span class="order-card-value">{{ order.order_card_info.remaining_text }}</span>
                                            </div>
                                            <div class="order-card-row">
                                                <span class="order-card-label">有效期：</span>
                                                <span class="order-card-value">{{ order.order_card_info.validity_text }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="view-btn-container">
                                    <van-button type="primary" size="small" class="view-details-btn"
                                        @click="viewOrderDetails(order)">
                                        查看详情
                                    </van-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
                <van-tab title="售卖机订单" name="vending">
                    <!-- 日期筛选 -->
                    <div class="date-filter">
                        <div class="filter-tabs">
                            <div v-for="(item, index) in dateTypes" :key="index"
                                :class="['filter-tab', { active: dateType === item.value }]"
                                @click="handleDateTypeChange(item.value)">
                                {{ item.label }}
                            </div>
                        </div>
                        <div class="date-picker">
                            <div class="date-range" @click="showDatePicker = true">
                                <span>{{ startDate || '开始日期' }} - {{ endDate || '结束日期' }}</span>
                                <van-icon name="calendar-o" />
                            </div>
                            <van-calendar v-model:show="showDatePicker" type="range" :min-date="minDate"
                                :max-date="maxDate" :allow-same-day="true" @confirm="onDateRangeConfirm" color="#8B0000"
                                v-if="showDatePicker" />
                        </div>
                    </div>
                    <!-- 售卖机订单内容 -->
                    <!-- 空状态 -->
                    <div v-if="vendingOrders.length === 0" class="empty-state">
                        <van-empty description="暂无售卖机订单" />
                    </div>
                    <!-- 订单列表 -->
                    <div v-else>
                        <div class="orders-content">
                            <div class="vending-order-card" v-for="order in vendingOrders" :key="order.id">
                                <div class="vending-order-header">
                                    <span>订单编号：{{ order.order_no }}</span>
                                </div>
                                <div class="vending-order-body">
                                    <div class="vending-order-row">
                                        <b>订单金额：</b>¥{{ order.order_amount }}
                                    </div>
                                    <div class="vending-order-row">
                                        <b>状态：</b>{{ order.state }}
                                    </div>
                                    <div class="vending-order-row">
                                        <b>购买产品：</b>{{ order.product_name }}
                                    </div>
                                    <div class="vending-order-row">
                                        <b>下单时间：</b>{{ order.order_time }}
                                    </div>
                                    <div class="vending-order-row">
                                        <b>机器名称：</b>{{ order.machine_id?.name }}
                                    </div>
                                    <div class="vending-order-row">
                                        <b>购买人：</b>{{ order.buyer_name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </PageLoading>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

const activeTab = ref('subscription')

// 日期筛选相关
const dateType = ref('month')
const showDatePicker = ref(false)
const startDate = ref('')
const endDate = ref('')

// 日期类型选项
const dateTypes = ref([
    { label: '日', value: 'day' },
    { label: '周', value: 'week' },
    { label: '月', value: 'month' },
])

// 日期范围限制
const minDate = new Date(new Date().getFullYear() - 1, 0, 1)
const maxDate = new Date(new Date().getFullYear() + 1, 11, 31)

// 订购订单数据
const subscriptionOrders = ref([])

// 售卖机订单数据
const vendingOrders = ref([])

// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}

// 跳转到卡片详情
const goToCardDetail = (cardInfo) => {
    if (!cardInfo || !cardInfo.card_info_id) return
    window.location.href = `/card-detail?card_id=${cardInfo.card_info_id}`
}

onMounted(() => {
    setWxTitle('我的订单')
    initPage()
    // 获取售卖机订单
    getVendingOrders()
})

// 页面初始化
const initPage = async () => {
    try {
        // 这里可以调用接口获取订单数据
        const res = await post('/api/select/community/order', {
            partner_id: parseInt(localStorage.getItem('userId')),
            company_ids: JSON.parse(localStorage.getItem('company_ids')),
            business_type: '校园订奶',
        })
        if (res.result && res.result.state === 'ok') {
            subscriptionOrders.value = res.result.order_arr
            // 处理订单数据,根据monday_list封装packages结构
            subscriptionOrders.value = subscriptionOrders.value.map(order => {
                order.packages = []
                if (Object.keys(order.monday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周一',
                        type: order.monday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.tuesday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周二',
                        type: order.tuesday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.wednesday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周三',
                        type: order.wednesday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.thursday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周四',
                        type: order.thursday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.friday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周五',
                        type: order.friday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.saturday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周六',
                        type: order.saturday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                if (Object.keys(order.sunday_list || {}).length > 0) {
                    order.packages.push({
                        day: '周日',
                        type: order.sunday_list.name === '酸奶' ? 'yogurt' : 'fresh'
                    })
                }
                return order
            })
        } else {
            handleError('加载失败', res.result?.message || '接口异常')
        }
    } catch (error) {
        console.error('页面初始化失败:', error)
        handleError('加载失败', '页面加载失败，请重试')
    } finally {
        loading.value = false
    }
}

// 获取售卖机订单
const getVendingOrders = async () => {
    try {
        const params = {
            partner_id: parseInt(localStorage.getItem('userId')),
        }
        if (dateType.value) {
            params.date_type = dateType.value
        }
        if (startDate.value) {
            params.start_date = startDate.value.replace(/\//g, '-')
            params.end_date = endDate.value.replace(/\//g, '-')
        }
        const res = await post('/api/select/retail/order', params)
        if (res.result && res.result.state === 'ok') {
            vendingOrders.value = res.result.order_arr
        } else {
            console.error('获取售卖机订单失败:', res.result?.message || '接口异常')
        }

    } catch (error) {
        console.error('获取售卖机订单失败:', error)
    }

}
// 查看订单详情
const viewOrderDetails = (order) => {
    console.log('查看订单详情:', order)
    // 跳转到订单详情页面
    window.location.href = '/order-detail?info=' + encodeURIComponent(JSON.stringify(order))
}

// 处理日期类型变化
const handleDateTypeChange = (type) => {
    dateType.value = type
    startDate.value = ''
    endDate.value = ''
    getVendingOrders()
}

// 处理日期范围确认
const onDateRangeConfirm = (values) => {
    startDate.value = formatDate(values[0])
    endDate.value = formatDate(values[1])
    showDatePicker.value = false
    dateType.value = false
    getVendingOrders()
}

// 格式化日期
const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}/${month}/${day}`
}

</script>

<style scoped>
.my-orders-page {
    background: #fff;
    min-height: 100vh;
}

:deep(.van-tabs__wrap) {
    padding: 14px 0;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
}

:deep(.van-tabs--line .van-tabs__wrap) {
    background: #fff;
}

.orders-content {
    padding: 0 10px 10px 10px;
}

.order-card {
    position: relative;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.cancelled-stamp {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 70px;
    height: 70px;
    border: 3px solid #DC2626;
    border-radius: 50%;
    color: #DC2626;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    transform: rotate(-30deg);
    z-index: 10;
    opacity: 0.8;
    pointer-events: none;
    box-shadow: inset 0 0 0 1px #DC2626;
}

.cancelled-stamp::after {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    border: 1px dashed #DC2626;
    border-radius: 50%;
}

.student-info {
    margin-bottom: 16px;
}

.student-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
}

.student-details {
    font-size: 14px;
    color: #6B7280;
}

.package-section {
    margin-bottom: 16px;
}

.section-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
}

/* 订单卡片样式 */
.order-card-section {
    margin-top: 14px;
    margin-bottom: 8px;
}

.order-card-display {
    background: linear-gradient(135deg, #FDF4F4 0%, #FAECEC 100%);
    border-radius: 12px;
    padding: 14px 16px;
    color: #1F2937;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    z-index: 10;
    -webkit-tap-highlight-color: rgba(139, 0, 0, 0.05);
    border-left: 3px solid #8B0000;
}

.order-card-display * {
    pointer-events: none;
}

.order-card-display:active {
    transform: scale(0.995);
    background: linear-gradient(135deg, #FAECEC 0%, #F6E3E3 100%);
}

.chip-card-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.order-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.order-card-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #8B0000;
}

.order-card-type-tag {
    background: rgba(139, 0, 0, 0.12);
    color: #8B0000;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
}

.order-card-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.order-card-row {
    display: flex;
    align-items: center;
    font-size: 13px;
}

.order-card-label {
    color: #6B7280;
    flex-shrink: 0;
    width: 54px;
    font-size: 12.5px;
}

.order-card-value {
    font-weight: 500;
    flex: 1;
    color: #374151;
}

.order-card-value.card-no {
    letter-spacing: 0.8px;
    font-size: 13px;
    color: #8B0000;
    font-weight: 600;
}

.milk-week-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.milk-week-item {
    display: flex;
    justify-content: center;
}

.milk-week-card {
    border: 1px solid #E5E7EB;
    border-radius: 7px;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 54px;
    position: relative;
}

.milk-week-title {
    font-size: 14px;
    font-weight: 500;
}

.milk-type-tag {
    position: absolute;
    top: 34px;
    right: 2px;
    color: #fff;
    font-size: 11px;
    font-weight: 500;
    border-radius: 50%;
    width: 21px;
    height: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}

.milk-icon {
    width: 16px;
    height: 32px;
    margin: 18px 0;
    display: block;
}

.milk-label {
    font-size: 11px;
    font-weight: 500;
}

.order-details {
    border-top: 1px solid #E5E7EB;
    padding-top: 16px;
}

.order-details .van-row {
    margin-bottom: 8px;
}

.order-details .van-row:last-child {
    margin-bottom: 0;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.detail-label {
    font-size: 14px;
    color: #6B7280;
}

.detail-value {
    font-size: 14px;
    color: #1F2937;
    font-weight: 500;
}

.detail-value.price {
    color: var(--van-primary-color);
}

.view-btn-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}

.view-details-btn {
    border: none;
    border-radius: 6px;
    font-size: 12px;
    padding: 6px 12px;
}

/* 售卖机订单样式 */
.vending-order-card {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.vending-order-header {
    font-size: 14px;
    color: #717070;
    margin-bottom: 12px;
    font-weight: 600;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(246, 246, 246, 1);
}

.vending-order-row {
    font-size: 14px;
    color: #333;
    margin-bottom: 8px;
    line-height: 1.5;
}

.vending-order-row b {
    font-weight: 500;
    color: #222;
}

.empty-state {
    padding: 60px 0;
    text-align: center;
}

/* 日期筛选样式 */
.date-filter {
    background: #fff;
    padding: 0 6px 12px 6px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #f0f0f0;
    position: sticky;
    top: 36px;
    z-index: 10;
}

.filter-tabs {
    display: flex;
    flex-shrink: 0;
    gap: 8px;
}

.filter-tab {
    font-size: 14px;
    color: #666;
    padding: 6px 12px;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.filter-tab.active {
    background: #8B0000;
    color: #fff;
}

.date-picker {
    position: relative;
    flex: 1;
}

.date-range {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f6f6f6;
    border-radius: 6px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
}

.date-range .van-icon {
    color: #999;
    font-size: 16px;
}
</style>